const defaultFilterMethod = (filter, row) => {
  return row[filter.id] && String(row[filter.id]).toLowerCase().search(filter.value.toLowerCase()) > -1;
}

export const reactTableDefaultProps = {
  filterable: true,
  defaultPageSize: 10,
  defaultFilterMethod,
  showPaginationBottom: true,
  className: "-striped -highlight",
  // Text
  previousText: '이전',
  nextText: '다음',
  loadingText: '로딩중...',
  noDataText: '데이터가 없습니다.',
  pageText: '페이지',
  ofText: '/',
  rowsText: '행',
}